<!-- <template>

</template> -->

<template>
    <div v-if="!loading" class="container-fluid">
      <div class="row no-gutters">
  
        <div class="col-md-3 d-flex flex-column bg-white border-right position-fixed" style="min-height: 100vh;">
  
          <div class="border-bottom shadow-sm p-3">
            <img src="@/assets/images/logo-only-oliver.png" class="img-fluid" alt="logo" />
          </div>
  
  
          <div class="mt-auto p-4 border-top">
            <div v-if="!client.signed_on">
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  :class="{ 'is-invalid': checkPolicy === false }"
                  type="checkbox"
                  v-model="checkPolicy"
                />
                <label class="form-check-label">
                  {{ $t("lang.label.terms_acceptance") }} 
                  <a class="text-primary" href="https://oliverlist.com/terms-of-services/" target="_blank">
                    {{ $t("lang.orders.i_agree").substr($t("lang.orders.i_agree").indexOf("[]") + 2) }}
                  </a>
                  annexées au présent contrat.
                </label>
              </div>
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  :class="{ 'is-invalid': checkAgree === false }"
                  type="checkbox"
                  v-model="checkAgree"
                />
                <label class="form-check-label">
                  {{ $t("lang.orders.i_understand").substr(0, $t("lang.orders.i_understand").indexOf("[]")) }}
                  <a class="text-primary" href="https://oliverlist.com/privacy-policy/" target="_blank">
                    {{ $t("lang.orders.i_understand").substr($t("lang.orders.i_understand").indexOf("[]") + 2) }}
                  </a>
                </label>
              </div>
              <button
                class="btn btn-primary w-100"
                :disabled="!checkAgree || !checkPolicy"
                @click="toogleModalCreditCard('open')"
              >
                {{ $t("lang.button.validate_proporsal") }}
              </button>
            </div>
  
            <div v-else>
              <h6 class="text-success">{{ $t("lang.label.congratulations") }}</h6>
              <small>{{ $t("lang.label.signed_on") }}: {{ getSignedOn }}</small><br />
              <small>{{ $t("lang.label.by") }}: {{ getUserBilling }}</small>
            </div>
          </div>
        </div>
        
        <LoadingSpinner v-if="loadingBankAccount" />
        <div v-else class="col-md-9 offset-md-3 d-flex justify-content-center align-items-start py-5" style="min-height: 100vh; background-color: navy; overflow-y: auto;">
          <div class="float-right position-absolute" style="top: 10px; right: 115px;">
            <button class="btn mt-1" 
              :class="btnLoading ? 'btn-secondary btn-loading' : 'btn-transparent-custom'"
              @click="getContract" :disabled="btnLoading">
              <i class="icon-download mr-2"></i>
              {{ $t("lang.button.downloadcontract") }}
            </button>
          </div>

          <div class="w-100 d-flex flex-column align-items-center px-4" style="max-width: 1100px;">
            <div class="card shadow-lg bg-white p-4 mt-2 mb-4" style="max-width: 1100px; width: 100%;">
  
              <div class="row mb-4">
                <div class="col-md-6">
                  <h5 class="font-weight-bold">AIVONI (Oliverlist)</h5>
                  <p class="mb-1">SIRET : 80878516600048</p>
                  <p class="mb-1">231 RUE SAINT-HONORE, 75001 PARIS France</p>
                  <p class="mb-0">TVA Intracommunautaire : FR32808785166</p>
                </div>
    
                <div class="col-md-6 text-right d-flex align-items-start justify-content-end">
                  <h4 class="font-weight-bold mb-0">{{ client.name }}</h4>
                </div>
              </div>

              <div v-if="client.kickoff_date" class="alert alert-primary mb-4" role="status">
                <strong>{{ $t("lang.label.proposal_kickoff_date") }}:</strong>
                {{ client.kickoff_date }}
              </div>
    
              <div class="px-3">
                <div class="row font-weight-bold border-bottom py-2">
                  <div class="col-md-7">{{ $t("lang.column.description") }}</div>
                  <div class="col-md-2">{{ $t("lang.label.price") }} H.T / unité</div>
                  <div class="col-md-1">Qte</div>
                  <div class="col-md-2">{{ $t("lang.label.price") }} H.T</div>
                </div>
    
    
                <div class="row py-3 border-bottom">
                  <div class="col-md-7">
                    <strong>{{ $t("lang.label.proporsal_subscription_1") }}</strong>
                    <p class="mb-2">
                      {{ $t("lang.label.proporsal_subscription_2") }}
                    </p>
                    <p class="mb-1"><em>{{ $t("lang.label.proporsal_subscription_3") }}</em></p>
                    <ul class="mb-0">
                      <li>
                        {{ $t("lang.label.proporsal_subscription_4") }}
                      </li>
                      <li>
                        {{ $t("lang.label.proporsal_subscription_6") }}
                      </li>
                    </ul>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.subscription_price_per_month.toFixed(2) }} € HT</div>
                  <div class="col-md-1 d-flex align-items-center">1</div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.subscription_price_per_month.toFixed(2) }} € HT</div>
                  <div class="col-md-7 d-flex align-items-center">
                    <p v-if="client.isFirstMonthFree == 1" class="mb-0 text-primary font-weight-bold">{{ $t("lang.label.special_offer_first_month_free") }}</p>
                  </div>
                </div>
    
                <div class="row py-3 border-bottom" v-if="client.dedicated_bookers > 0">
                  <div class="col-md-7">
                    <strong> {{ $t("lang.label.proporsal_bookers_1") }} </strong>
                    <p class="mb-0">
                      {{ $t("lang.label.proporsal_bookers_2") }}
                    </p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.bookers_price_per_month.toFixed(2) }} € HT</div>
                  <div class="col-md-1 d-flex align-items-center">{{ client.dedicated_bookers }}</div>
                  <div class="col-md-2 d-flex align-items-center">
                    {{ (client.dedicated_bookers * client.bookers_price_per_month).toFixed(2) }} € HT
                  </div>
                </div>

                <div class="row py-3 border-bottom" v-if="client.contacts_active > 0">
                  <div class="col-md-7">
                    <strong> {{ $t("lang.label.proporsal_contacts_1") }} </strong>
                    <p class="mb-0">
                      {{ $t("lang.label.proporsal_contacts_2") }}
                    </p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.contacts_price_per_month.toFixed(2) }} € HT</div>
                  <div class="col-md-1 d-flex align-items-center">1</div>
                  <div class="col-md-2 d-flex align-items-center">
                    {{ (client.contacts_price_per_month).toFixed(2) }} € HT
                  </div>
                </div>

                <div class="row py-3" v-if="client.proposal_meeting_price > 0 && client.proposal_meeting_price != null && client.proposal_meeting_price != undefined"> 
                  <div class="col-md-7">
                    <strong>{{ $t("lang.label.proporsal_price_meeting_1") }}</strong>
                    <p class="mb-0">
                      {{ $t("lang.label.proporsal_price_meeting_2") }}
                    </p>
                  </div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.proposal_meeting_price.toFixed(2) }} € HT</div>
                  <div class="col-md-1 d-flex align-items-center">/unité</div>
                  <div class="col-md-2 d-flex align-items-center">{{ client.proposal_meeting_price.toFixed(2) }} € HT</div>
                </div>
              </div>


            </div>

            <!-- CGU Oliverlist — i18n: lang.conditionsGeneralProposal -->
            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="text-uppercase">{{ $t("lang.conditionsGeneralProposal.cgu_main_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_intro_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_intro_p2") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s1_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s1_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s1_services_label") }}</p>
              <ol type="i" class="pl-4">
                <li class="mb-2">{{ $t("lang.conditionsGeneralProposal.cgu_s1_li_i") }}</li>
                <li class="mb-2">{{ $t("lang.conditionsGeneralProposal.cgu_s1_li_ii") }}</li>
                <li class="mb-2">{{ $t("lang.conditionsGeneralProposal.cgu_s1_li_iii") }}</li>
                <li class="mb-2">{{ $t("lang.conditionsGeneralProposal.cgu_s1_li_iv") }}</li>
              </ol>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s2_title") }}</h2>
              <p>{{ $t(cguKey("cgu_s2_p1")) }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s2_p2") }}</p>
              <p class="mb-0">{{ $t("lang.conditionsGeneralProposal.cgu_s2_p3") }}</p>
            </div>

            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s3_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s3_p1") }}</p>
              <template v-if="usesTermsV2">
                <h3 class="font-weight-bold mt-3">{{ $t(cguKey("cgu_s31_kickoff_title")) }}</h3>
                <p>{{ $t(cguKey("cgu_s31_kickoff_p1")) }}</p>
                <p>{{ $t(cguKey("cgu_s31_kickoff_p2")) }}</p>
                <p>{{ $t(cguKey("cgu_s31_kickoff_p3")) }}</p>
              </template>
              <h3 class="font-weight-bold mt-3">{{ $t(cguKey("cgu_s31_title")) }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s31_p1") }}</p>
              <ul class="mb-3">
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_1") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_2") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_3") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_4") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_5") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_6") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s31_li_7") }}</li>
              </ul>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s31_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t(cguKey("cgu_s32_title")) }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s32_intro") }}</p>
              <ul class="mb-3">
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s32_li_1") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s32_li_2") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s32_li_3") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s32_li_4") }}</li>
              </ul>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s32_p1") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t(cguKey("cgu_s33_title")) }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s33_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s33_p2") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s33_cooperation_html')"></p>
              <p v-if="client.bank_transfer_enabled == 1" v-html="$t('lang.conditionsGeneralProposal.card2_content_bank_transfer', { bank_transfer_contractual_days: client.bank_transfer_contractual_days })"></p>
              <p v-else v-html="$t('lang.conditionsGeneralProposal.card2_content3')"></p>
            </div>

            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s4_title") }}</h2>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s41_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s41_p1") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s41_ident_html')"></p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s41_enrich_html')"></p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s41_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s42_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s42_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s42_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s43_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s43_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s43_p2") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s43_p3") }}</p>
              <ul class="mb-0">
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s43_li_1") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s43_li_2") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s43_li_3") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s43_li_4") }}</li>
              </ul>
              <p class="mt-3 mb-0">{{ $t("lang.conditionsGeneralProposal.cgu_s43_p4") }}</p>
            </div>

            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h3 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s44_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s44_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s44_p2") }}</p>
              <ul class="mb-3">
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s44_li_1") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s44_li_2") }}</li>
              </ul>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s44_p3") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s45_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s45_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s45_p2") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s5_title") }}</h2>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s51_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s51_p1") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s51_i_html')"></p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s51_ii_html')"></p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s51_p2") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s51_p3") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s52_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s52_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s52_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s53_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s53_intro") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s53_crit1_html')"></p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s53_crit2_html')"></p>
              <p class="mb-0" v-html="$t('lang.conditionsGeneralProposal.cgu_s53_crit3_html')"></p>
            </div>

            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s6_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s6_p1") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s61_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s61_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s61_p2") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s61_p3") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s62_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s62_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s62_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s63_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s63_intro") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s63_a") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s63_b") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s63_c") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s63_d") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s64_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s64_intro") }}</p>
              <ul class="mb-3">
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s64_li_1") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s64_li_2") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s64_li_3") }}</li>
                <li>{{ $t("lang.conditionsGeneralProposal.cgu_s64_li_4") }}</li>
              </ul>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s64_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s64_p2") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s7_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s7_p1") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s71_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s71_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s71_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s72_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s72_p1") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s73_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s73_p1") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s73_notice_html')"></p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s8_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s8_p1") }}</p>
              <p class="mb-0">{{ $t("lang.conditionsGeneralProposal.cgu_s8_p2") }}</p>
            </div>

            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s9_title") }}</h2>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s91_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s91_p1") }}</p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s91_i_html')"></p>
              <p v-html="$t('lang.conditionsGeneralProposal.cgu_s91_ii_html')"></p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s91_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s92_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s92_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s92_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s93_title") }}</h3>
              <p class="mb-4">{{ $t("lang.conditionsGeneralProposal.cgu_s93_p1") }}</p>
              <h2 class="font-weight-bold">{{ $t("lang.conditionsGeneralProposal.cgu_s10_title") }}</h2>
              <template v-if="usesTermsV2">
                <p>{{ $t(cguKey("cgu_s10_p1")) }}</p>
                <p>{{ $t(cguKey("cgu_s10_p2")) }}</p>
                <p>{{ $t(cguKey("cgu_s10_p3")) }}</p>
              </template>
              <p v-else>{{ $t("lang.conditionsGeneralProposal.cgu_s10_p1") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s11_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s11_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s11_p2") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s11_p3") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s12_title") }}</h2>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s121_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s121_p1") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s122_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s122_p1") }}</p>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s122_p2") }}</p>
              <h3 class="font-weight-bold mt-3">{{ $t("lang.conditionsGeneralProposal.cgu_s123_title") }}</h3>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s123_p1") }}</p>
              <h2 class="font-weight-bold mt-4">{{ $t("lang.conditionsGeneralProposal.cgu_s13_title") }}</h2>
              <p>{{ $t("lang.conditionsGeneralProposal.cgu_s13_p1") }}</p>
              <p class="mb-0">{{ $t("lang.conditionsGeneralProposal.cgu_s13_p2") }}</p>
              <p class="mt-4 mb-0 font-weight-bold text-center">{{ $t("lang.conditionsGeneralProposal.cgu_footer_end") }}</p>
            </div>

            <!-- CGV — i18n: lang.conditionsSalesProposal (contenu aligné sur le PDF source) -->
            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <h2 class="text-uppercase">{{ $t("lang.conditionsSalesProposal.cgv_main_title") }}</h2>
            </div>
            <div
              v-for="section in cgvCardSections"
              :key="section + cgvVersionSuffix"
              class="card shadow-lg bg-white p-4 mb-4 text-justify"
              style="width: 100%;"
            >
              <div v-html="$t('lang.conditionsSalesProposal.cgv_card_' + section + cgvVersionSuffix + '_html')"></div>
            </div>
            <div class="card shadow-lg bg-white p-4 mb-4 text-justify" style="width: 100%;">
              <p class="mb-0 font-weight-bold text-center">{{ $t("lang.conditionsSalesProposal.cgv_footer_end") }}</p>
            </div>
          </div>

        </div>

      </div>
      
      <div style="opacity: 0;">
        <!-- Misma estructura que Account.vue: contenido dentro del Modal y @opened en Modal -->
        <Modal :name="'pdf-modal'" @opened="onModalOpened">
          <TermsAndConditionsProposalHtml :client="paymentProfile" />
        </Modal>
      </div>

      <Modal class="rounded" :name="'confirm'" v-if="client.id" :size="'35'" :close="true" :scrollable="false">
        <div class="px-3 py-4 px-md-4">
          <ContractSignProposalModal
            ref="creditCardForm"
            :profileData="true"
            @closeCreditCardModal="closeCreditCardModal"
            @reloadComponent="reloadComponent"
            :userId="userBilling.id"
            :email="userBilling.email"
            :name="billingName"
            :client_name="userBilling.client_name"
            :fromProporsal="false"
            :bank_transfer_enabled="client.bank_transfer_enabled"
            :bank_transfer_contractual_days="client.bank_transfer_contractual_days"
          />
        </div>
      </Modal>
    </div>
</template>


<script>
import { proporsalService } from "@/_services";
import ProporsalOrderDetail from "./ProporsalOrderDetail.vue";
import ContractSignProposalModal from "@/components/Billing/ContractSignProposalModal.vue";
import Modal from "@/components/Common/Modal.vue";
import SpecialDiscountOrderNotification from "@/components/SpecialDiscountOrderNotification.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import TermsAndConditionsProposalHtml from "./TermsAndConditionsProposalHtml.vue";
import { formattersMixin, pdfTermsAndConditionsMixin } from "@/_mixins/";
import i18n from "@/_helpers/i18n";
import moment from "moment";
import { mapState } from "vuex/dist/vuex.common.js";

const TERMS_V2_CUTOVER_LOCAL = "2026-08-01 00:00:00";
const TERMS_V2_CUTOVER_TIMESTAMP = Date.parse("2026-08-01T00:00:00+02:00");

function signedContractUsesTermsV2(signedOn) {
  const normalized = String(signedOn).trim().replace("T", " ");

  // Database timestamps are stored as Paris local time without an offset.
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(normalized)) {
    return normalized >= TERMS_V2_CUTOVER_LOCAL;
  }

  const timestamp = Date.parse(signedOn);
  return Number.isFinite(timestamp) && timestamp >= TERMS_V2_CUTOVER_TIMESTAMP;
}

export default {
  name: "ClientServiceProporsal",
  components: {
    ProporsalOrderDetail,
    ContractSignProposalModal,
    Modal,
    SpecialDiscountOrderNotification,
    LoadingSpinner,
    TermsAndConditionsProposalHtml
  },
  computed: {
    ...mapState("billings", {
      loadingBankAccount: "loading",
    }),
    launch_date_campaign() {
      return (date) => {
        return moment(date).format("MM-DD-YYYY");
      };
    },
    isOrderSelected() {
      return (orderId) => {
        const isVisible = this.listOrders.find(
          (order) => order.target_id === orderId
        ).visible;
        return isVisible ? "-" : "+";
      };
    },
    getSignedOn() {
      return moment(this.client.signed_on).format("MM-DD-YYYY");
    },
    getUserBilling() {
      return this.userBilling.name + " " + this.userBilling.lastname;
    },
    cgvCardSections() {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    },
    usesTermsV2() {
      if (this.client && this.client.signed_on) {
        return signedContractUsesTermsV2(this.client.signed_on);
      }
      return Date.now() >= TERMS_V2_CUTOVER_TIMESTAMP;
    },
    cgvVersionSuffix() {
      return this.usesTermsV2 ? "_v2" : "";
    },
    cguKey() {
      return (key) => `lang.conditionsGeneralProposal.${key}${this.cgvVersionSuffix}`;
    },
  },
  data() {
    return {
      loading: true,
      paramloading: {
        width: '18px',
        height: '18px',
        color: '#5054EB'
      },
      listOrders: [],
      client: {},
      userBilling: {},
      billingName: "",
      btnLoading: false,
      orderToShow: null,
      orderSelect: {},
      checkAgree: null,
      checkPolicy: null,
      paymentProfile: null,
      specialOrderDiscountCountDown: "",
      clientId: 0,
    };
  },

  created() {
    if (typeof this.$route.params.clientId !== "undefined") {
      this.clientId = this.$route.params.clientId;
      this.getOrders(this.clientId);
    }
  },

  mixins: [formattersMixin, pdfTermsAndConditionsMixin],

  methods: {
    openModal(modalId) {
      this.btnLoading = true;
      this.$modal.show(modalId);
    },
    onModalOpened() {
      this.downloadTermsAndConditionsPDF((this.namePDF = 3))
        .then(() => {
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        })
        .finally(() => {
          this.btnLoading = false;
          this.$modal.hide("pdf-modal");
        });
    },
    closeCreditCardModal() {
      this.$modal.hide("confirm");
    },
    reloadComponent() {
      this.getOrders(this.clientId);
    },
    toogleModalCreditCard(action) {
      if (action === "open") {
        this.$modal.show("confirm");
      } else {
        this.$modal.hide("confirm");
      }
    },
    getOrders(clientId) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "Redirection-Parcours Commercial",
      });
      proporsalService
        .getOrders(clientId)
        .then((res) => {
          this.loading = false;
          this.client = {
            ...res.client,
            dedicated_bookers: Number(res.client.dedicated_bookers) || 0,
            proposal_meeting_price: res.client.proposal_meeting_price != null ? Number(res.client.proposal_meeting_price) : 0,
            subscription_price_per_month: Number(res.client.subscription_price_per_month) || 0,
            bookers_price_per_month: Number(res.client.bookers_price_per_month) || 0,
            contacts_active: Number(res.client.contacts_active) || 0,
            contacts_price_per_month: Number(res.client.contacts_price_per_month) || 0,
          };
          this.userBilling = res.userBilling;
          this.paymentProfile = res.paymentProfile == null ? null : res.paymentProfile;

          this.billingName = this.userBilling.name + " " + this.userBilling.lastname;

          //Configuro idiona de acuerdo al idioma del user billing
          if (this.userBilling.language_id) {
            switch (this.userBilling.language_id) {
              case "1":
                i18n.locale = "fr";
                break;
              case "3":
                i18n.locale = "es";
                break;
              case "4":
                i18n.locale = "it";
                break;
              case "5":
                i18n.locale = "pt";
                break;
              default:
                i18n.locale = "en";
                break;
            }
          }

          this.listOrders = res.orders.length > 0 ? res.orders.map((el) => ({ ...el, visible: false })) : [];
        })
        .catch((err) => console.log(err));
    },

    showOrder(targetId = null) {
      const isVisible = this.listOrders.find(
        (el) => el.target_id === targetId
      ).visible;

      if (isVisible) {
        this.listOrders.find((el) => el.target_id === targetId).visible = false;
      } else {
        if (targetId) {
          this.listOrders = this.listOrders.map((el) => ({
            ...el,
            visible: false,
          }));
          this.listOrders.find(
            (el) => el.target_id === targetId
          ).visible = true;
        } else {
          this.orderToShow = null;
        }
      }
    },

    setSpecialOrderDiscountCountDown(specialOrderDiscountCountDown) {
      this.specialOrderDiscountCountDown = specialOrderDiscountCountDown;
    },

    getContract() {
      this.btnLoading = true;
      proporsalService
        .getContractClient(this.clientId)
        .then(({ blob, filename }) => {
          const downloadName = filename
            ? filename.endsWith(".pdf")
              ? filename
              : `${filename}.pdf`
            : `contract-${this.clientId}.pdf`;
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: "application/octet-stream" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.download = downloadName;
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          link.remove();
          setTimeout(() => window.URL.revokeObjectURL(url), 200);
          this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.btn-transparent-custom {
  background-color: transparent;
  color: white;
  transition: all 0.3s ease;
}

.btn-transparent-custom:hover {
  background-color: white;
  color: #1a237e;
}
</style>
